"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDeleteImportErrorMockData = exports.buildDeleteImportSuccessMockData = exports.buildUserCardExpiringMockData = exports.buildUserFailedRecurringCardPaymentMockData = exports.buildUserFailedPadAchMockData = exports.buildNpoStarterInvitationMockData = exports.buildInvitationRefusedMockData = exports.buildInvitationSecondReminderMockData = exports.buildInvitationFirstReminderMockData = exports.buildMergeUsersRequestMockData = exports.buildOwnershipTransferredMockData = exports.buildAdminRevokedMockData = exports.buildCollaboratorAppInviteMockData = exports.buildAdminAddedMockData = exports.buildOrganizationInvitationMockData = exports.buildOrganizationCreatedMockData = exports.buildNewDeviceMockData = exports.buildUserEmailChangedMockData = exports.buildContactEmailChangedMockData = exports.buildPasswordChangedMockData = exports.buildEmailChangedMockData = exports.buildEmailVerificationMockData = exports.buildAssistantVerificationCodeMockData = exports.buildResetPasswordMockData = void 0;
const locales_1 = require("../../internationalization/enums/locales");
const locales_2 = require("../../internationalization/features/locales");
const mobile_app_links_1 = require("../../helpers/mobile-app-links");
const contact_facing_1 = require("./contact-facing");
const organization_facing_base_1 = require("./organization-facing-base");
const ORG_NAME = "Bright Futures Foundation";
const RESET_PASSWORD_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Reset your password",
    [locales_1.Locales.FR]: "Réinitialisez votre mot de passe",
    [locales_1.Locales.ES]: "Restablezca su contraseña",
    [locales_1.Locales.DE]: "Setzen Sie Ihr Passwort zurück",
});
const buildResetPasswordMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(RESET_PASSWORD_SUBJECT, locale), firstName = "John", resetPasswordLink = "https://www.zeffy.com/en-US/reset-password?token=sandbox-token", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    resetPasswordLink,
});
exports.buildResetPasswordMockData = buildResetPasswordMockData;
const ASSISTANT_VERIFICATION_CODE_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Your Zeffy verification code",
    [locales_1.Locales.FR]: "Votre code de vérification Zeffy",
    [locales_1.Locales.ES]: "Su código de verificación de Zeffy",
    [locales_1.Locales.DE]: "Ihr Zeffy-Bestätigungscode",
});
const buildAssistantVerificationCodeMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(ASSISTANT_VERIFICATION_CODE_SUBJECT, locale), code = "482913", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    code,
});
exports.buildAssistantVerificationCodeMockData = buildAssistantVerificationCodeMockData;
const EMAIL_VERIFICATION_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Verify your email address",
    [locales_1.Locales.FR]: "Confirmez votre adresse courriel",
    [locales_1.Locales.ES]: "Confirme su dirección de correo electrónico",
    [locales_1.Locales.DE]: "Bestätigen Sie Ihre E-Mail-Adresse",
});
const buildEmailVerificationMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(EMAIL_VERIFICATION_SUBJECT, locale), firstName = "John", validationLink = "https://www.zeffy.com/en-US/verify-email?token=sandbox-token", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    validationLink,
});
exports.buildEmailVerificationMockData = buildEmailVerificationMockData;
const ACCOUNT_CHANGE_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "A change has been made to your account",
    [locales_1.Locales.FR]: "Un changement a été apporté à votre compte",
    [locales_1.Locales.ES]: "Se ha realizado un cambio en su cuenta",
    [locales_1.Locales.DE]: "An Ihrem Konto wurde eine Änderung vorgenommen",
});
const buildEmailChangedMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(ACCOUNT_CHANGE_SUBJECT, locale), firstName = "John", newEmail = "j***@brightfutures.org", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    newEmail,
});
exports.buildEmailChangedMockData = buildEmailChangedMockData;
const buildPasswordChangedMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(ACCOUNT_CHANGE_SUBJECT, locale), firstName = "John", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
});
exports.buildPasswordChangedMockData = buildPasswordChangedMockData;
const CONTACT_EMAIL_CHANGED_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "One of your supporters has updated their contact information",
    [locales_1.Locales.FR]: "L'un de vos contacts Zeffy a mis à jour ses coordonnées",
    [locales_1.Locales.ES]: "Uno de sus donantes ha actualizado sus datos de contacto",
    [locales_1.Locales.DE]: "Eine Person aus Ihrem Unterstützerkreis hat die Kontaktdaten aktualisiert",
});
const buildContactEmailChangedMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(CONTACT_EMAIL_CHANGED_SUBJECT, locale), firstName = "John", oldEmail = "jane.donor@maildrop.cc", newEmail = "jane.donor+new@maildrop.cc", dashboardUrl = "https://www.zeffy.com/en-US/o/crm/contacts?contactId=sandbox-contact", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    oldEmail,
    newEmail,
    dashboardUrl,
});
exports.buildContactEmailChangedMockData = buildContactEmailChangedMockData;
const buildUserEmailChangedMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(ACCOUNT_CHANGE_SUBJECT, locale), firstName = "John", userOldEmail = "john@brightfutures.org", userNewEmail = "john.doe@brightfutures.org", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    userOldEmail,
    userNewEmail,
});
exports.buildUserEmailChangedMockData = buildUserEmailChangedMockData;
const NEW_DEVICE_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Connection from a new device",
    [locales_1.Locales.FR]: "Un nouvel appareil a été utilisé",
    [locales_1.Locales.ES]: "Conexión desde un nuevo dispositivo",
    [locales_1.Locales.DE]: "Anmeldung von einem neuen Gerät",
});
const buildNewDeviceMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(NEW_DEVICE_SUBJECT, locale), firstName = "John", country = "Canada", region = "Quebec", city = "Montréal", date = "2026-03-14, 9:41:00 AM", deviceInformation = "Chrome on macOS", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    country,
    region,
    city,
    date,
    deviceInformation,
});
exports.buildNewDeviceMockData = buildNewDeviceMockData;
const ORGANIZATION_CREATED_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "John, welcome to Zeffy!",
    [locales_1.Locales.FR]: "John, bienvenue chez Zeffy",
    [locales_1.Locales.ES]: "John, ¡bienvenido/a a Zeffy!",
    [locales_1.Locales.DE]: "John, willkommen bei Zeffy!",
});
const buildOrganizationCreatedMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(ORGANIZATION_CREATED_SUBJECT, locale), firstName = "John", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
});
exports.buildOrganizationCreatedMockData = buildOrganizationCreatedMockData;
const ORGANIZATION_INVITATION_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: `Marie has invited you to ${ORG_NAME}'s Zeffy account`,
    [locales_1.Locales.FR]: `Marie vous invite au compte Zeffy de ${ORG_NAME}`,
    [locales_1.Locales.ES]: `Marie le ha invitado a la cuenta de Zeffy de ${ORG_NAME}`,
    [locales_1.Locales.DE]: `Marie hat Sie zum Zeffy-Konto von ${ORG_NAME} eingeladen`,
});
const buildOrganizationInvitationMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(ORGANIZATION_INVITATION_SUBJECT, locale), userFirstName = "John", userLastName = "Doe", firstName = "Marie", orgName = ORG_NAME, invitationLink = "https://www.zeffy.com/en-US/login?invitation=sandbox-token", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    userFirstName,
    userLastName,
    firstName,
    orgName,
    invitationLink,
});
exports.buildOrganizationInvitationMockData = buildOrganizationInvitationMockData;
const buildAdminAddedMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(ACCOUNT_CHANGE_SUBJECT, locale), firstName = "John", orgName = ORG_NAME, newAdminName = "Marie Curie", newAdminEmail = "marie@brightfutures.org", appOnlyAccess, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    orgName,
    newAdminName,
    newAdminEmail,
    ...(appOnlyAccess
        ? {
            appOnlyAccess: true,
            appOnlyCanTakePayments: appOnlyAccess.canTakePayments,
            appOnlyCampaigns: appOnlyAccess.campaigns,
        }
        : {}),
});
exports.buildAdminAddedMockData = buildAdminAddedMockData;
const COLLABORATOR_APP_INVITE_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "François has invited you to join them on the Zeffy app",
    [locales_1.Locales.FR]: "François vous invite à utiliser l'application Zeffy",
    [locales_1.Locales.ES]: "François le ha invitado a unirse a la aplicación Zeffy",
    [locales_1.Locales.DE]: "François hat Sie zur Zeffy-App eingeladen",
});
const PREVIEW_QR_CODE_SRC = `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160"><rect width="160" height="160" fill="#0F0E5B"/><rect x="16" y="16" width="128" height="128" fill="#FFFFFF"/><rect x="32" y="32" width="96" height="96" fill="#0F0E5B"/></svg>')}`;
const buildCollaboratorAppInviteMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(COLLABORATOR_APP_INVITE_SUBJECT, locale), inviterFirstName = "François", campaignTitle = "Annual Gala 2026", setUpAccountLink = null, isTapToPaySupported = true, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    inviterFirstName,
    campaignTitle,
    setUpAccountLink,
    isTapToPaySupported,
    qrCodeSrc: PREVIEW_QR_CODE_SRC,
    appStoreUrl: (0, mobile_app_links_1.getAppStoreUrl)(),
    playStoreUrl: (0, mobile_app_links_1.getPlayStoreUrl)(),
});
exports.buildCollaboratorAppInviteMockData = buildCollaboratorAppInviteMockData;
const buildAdminRevokedMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(ACCOUNT_CHANGE_SUBJECT, locale), firstName = "John", orgName = ORG_NAME, adminName = "Marie Curie", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    orgName,
    adminName,
});
exports.buildAdminRevokedMockData = buildAdminRevokedMockData;
const buildOwnershipTransferredMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(ACCOUNT_CHANGE_SUBJECT, locale), firstName = "John", orgName = ORG_NAME, adminName = "Marie Curie", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    orgName,
    adminName,
});
exports.buildOwnershipTransferredMockData = buildOwnershipTransferredMockData;
const MERGE_USERS_REQUEST_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Confirm your email change",
    [locales_1.Locales.FR]: "Confirmez votre changement d'adresse courriel",
    [locales_1.Locales.ES]: "Confirme su cambio de correo electrónico",
    [locales_1.Locales.DE]: "Bestätigen Sie Ihre E-Mail-Änderung",
});
const buildMergeUsersRequestMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(MERGE_USERS_REQUEST_SUBJECT, locale), firstName = "John", oldEmail = "john@brightfutures.org", newEmail = "john.doe@brightfutures.org", mergeLink = "https://www.zeffy.com/en-US/merge-users?token=sandbox-token", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    oldEmail,
    newEmail,
    mergeLink,
});
exports.buildMergeUsersRequestMockData = buildMergeUsersRequestMockData;
const INVITATION_FIRST_REMINDER_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Don't miss Marie's invitation to Zeffy!",
    [locales_1.Locales.FR]: "Ne manquez pas l'invitation de Marie à Zeffy !",
    [locales_1.Locales.ES]: "¡No se pierda la invitación de Marie a Zeffy!",
    [locales_1.Locales.DE]: "Verpassen Sie die Einladung von Marie zu Zeffy nicht!",
});
const buildInvitationFirstReminderMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(INVITATION_FIRST_REMINDER_SUBJECT, locale), userFirstName = "John", firstName = "Marie", orgName = ORG_NAME, invitationLink = "https://www.zeffy.com/en-US/login?invitation=sandbox-token", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    userFirstName,
    firstName,
    orgName,
    invitationLink,
});
exports.buildInvitationFirstReminderMockData = buildInvitationFirstReminderMockData;
const INVITATION_SECOND_REMINDER_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: `Last reminder to join ${ORG_NAME}'s team on Zeffy!`,
    [locales_1.Locales.FR]: `Dernier rappel pour rejoindre l'équipe de ${ORG_NAME} sur Zeffy !`,
    [locales_1.Locales.ES]: `¡Último recordatorio para unirse al equipo de ${ORG_NAME} en Zeffy!`,
    [locales_1.Locales.DE]: `Letzte Erinnerung: Treten Sie dem Team von ${ORG_NAME} auf Zeffy bei!`,
});
const buildInvitationSecondReminderMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(INVITATION_SECOND_REMINDER_SUBJECT, locale), userFirstName = "John", firstName = "Marie", orgName = ORG_NAME, invitationLink = "https://www.zeffy.com/en-US/login?invitation=sandbox-token", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    userFirstName,
    firstName,
    orgName,
    invitationLink,
});
exports.buildInvitationSecondReminderMockData = buildInvitationSecondReminderMockData;
const INVITED_USER_EMAIL = "john.doe@brightfutures.org";
const INVITATION_REFUSED_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: `${INVITED_USER_EMAIL} hasn't accepted your invitation to Zeffy yet`,
    [locales_1.Locales.FR]: `${INVITED_USER_EMAIL} n'a pas encore accepté votre invitation à Zeffy`,
    [locales_1.Locales.ES]: `${INVITED_USER_EMAIL} todavía no ha aceptado su invitación a Zeffy`,
    [locales_1.Locales.DE]: `${INVITED_USER_EMAIL} hat Ihre Einladung zu Zeffy noch nicht angenommen`,
});
const buildInvitationRefusedMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(INVITATION_REFUSED_SUBJECT, locale), userEmail = INVITED_USER_EMAIL, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    userEmail,
});
exports.buildInvitationRefusedMockData = buildInvitationRefusedMockData;
const NPO_STARTER_501C3_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: `Great news! ${ORG_NAME} is eligible for 501(c)(3) status 🎉`,
    [locales_1.Locales.FR]: `Bonne nouvelle ! ${ORG_NAME} est admissible au statut 501(c)(3) 🎉`,
    [locales_1.Locales.ES]: `¡Buenas noticias! ${ORG_NAME} cumple los requisitos para el estatus 501(c)(3) 🎉`,
    [locales_1.Locales.DE]: `Gute Nachrichten! ${ORG_NAME} erfüllt die Voraussetzungen für den 501(c)(3)-Status 🎉`,
});
const NPO_STARTER_INCORPORATED_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: `${ORG_NAME} is officially incorporated! Here's what's next 🎉`,
    [locales_1.Locales.FR]: `${ORG_NAME} est officiellement constitué ! Voici la suite 🎉`,
    [locales_1.Locales.ES]: `¡${ORG_NAME} ya está oficialmente constituida! Esto es lo que sigue 🎉`,
    [locales_1.Locales.DE]: `${ORG_NAME} ist offiziell gegründet! So geht es weiter 🎉`,
});
const buildNpoStarterInvitationMockData = ({ locale = "en", is501c3Eligible = true, subject = (0, organization_facing_base_1.pickForLocale)(is501c3Eligible ? NPO_STARTER_501C3_SUBJECT : NPO_STARTER_INCORPORATED_SUBJECT, locale), orgName = ORG_NAME, ctaLabel = "Join Zeffy", ctaLink = "https://www.zeffy.com/en-US/login?invitation=sandbox-token", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    is501c3Eligible,
    orgName,
    ctaLabel,
    ctaLink,
});
exports.buildNpoStarterInvitationMockData = buildNpoStarterInvitationMockData;
const USER_FAILED_PAD_ACH_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: `Your payment to ${ORG_NAME} failed`,
    [locales_1.Locales.FR]: `Votre paiement à ${ORG_NAME} a échoué`,
    [locales_1.Locales.ES]: `Su pago a ${ORG_NAME} no se ha realizado`,
    [locales_1.Locales.DE]: `Ihre Zahlung an ${ORG_NAME} ist fehlgeschlagen`,
});
const buildUserFailedPadAchMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(USER_FAILED_PAD_ACH_SUBJECT, locale), fullName = "Jane Donor", buyerName = "Jane Donor", buyerEmail = "jane.donor@maildrop.cc", amount = "$120.00", transactionDate = "March 14, 2026, 9:41 AM", ...base }) => ({
    ...(0, contact_facing_1.buildContactFacingBase)({ ...base, locale, subject }),
    fullName,
    buyerName,
    buyerEmail,
    amount,
    transactionDate,
});
exports.buildUserFailedPadAchMockData = buildUserFailedPadAchMockData;
const USER_FAILED_RECURRING_CARD_PAYMENT_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: `We couldn't process your recurring donation of $25.00 to ${ORG_NAME}`,
    [locales_1.Locales.FR]: `Nous n'avons pas pu traiter votre don récurrent de 25,00 $ pour ${ORG_NAME}`,
    [locales_1.Locales.ES]: `No hemos podido procesar su donación recurrente de 25,00 $ para ${ORG_NAME}`,
    [locales_1.Locales.DE]: `Wir konnten Ihre wiederkehrende Spende über 25,00 $ an ${ORG_NAME} nicht verarbeiten`,
});
const PROGRAM_TYPE_LABEL = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "recurring donation",
    [locales_1.Locales.FR]: "don récurrent",
    [locales_1.Locales.ES]: "donación recurrente",
    [locales_1.Locales.DE]: "wiederkehrende Spende",
});
const PROGRAM_TYPE_LABEL_SHORT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "donation",
    [locales_1.Locales.FR]: "don",
    [locales_1.Locales.ES]: "donación",
    [locales_1.Locales.DE]: "Spende",
});
const buildUserFailedRecurringCardPaymentMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(USER_FAILED_RECURRING_CARD_PAYMENT_SUBJECT, locale), fullName = "Jane Donor", amount = "$25.00", programTypeLabel = (0, organization_facing_base_1.pickForLocale)(PROGRAM_TYPE_LABEL, locale), programTypeLabelShort = (0, organization_facing_base_1.pickForLocale)(PROGRAM_TYPE_LABEL_SHORT, locale), updatePaymentUrl = "https://billing.stripe.com/session/sandbox", ...base }) => ({
    ...(0, contact_facing_1.buildContactFacingBase)({ ...base, locale, subject }),
    fullName,
    amount,
    programTypeLabel,
    programTypeLabelShort,
    updatePaymentUrl,
});
exports.buildUserFailedRecurringCardPaymentMockData = buildUserFailedRecurringCardPaymentMockData;
const USER_CARD_EXPIRING_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Heads up! Your card is about to expire 💳",
    [locales_1.Locales.FR]: "Attention ! Votre carte va bientôt expirer 💳",
    [locales_1.Locales.ES]: "¡Atención! Su tarjeta está a punto de caducar 💳",
    [locales_1.Locales.DE]: "Achtung! Ihre Karte läuft bald ab 💳",
});
const buildUserCardExpiringMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(USER_CARD_EXPIRING_SUBJECT, locale), firstName = "Jane", programTypeLabel = (0, organization_facing_base_1.pickForLocale)(PROGRAM_TYPE_LABEL, locale), renewDate = "April 1, 2026, 9:41 AM", renewPrice = "$25.00", last4PaymentMethod = "4242", updatePaymentUrl = "https://billing.stripe.com/session/sandbox", ...base }) => ({
    ...(0, contact_facing_1.buildContactFacingBase)({ ...base, locale, subject }),
    firstName,
    programTypeLabel,
    renewDate,
    renewPrice,
    last4PaymentMethod,
    updatePaymentUrl,
});
exports.buildUserCardExpiringMockData = buildUserCardExpiringMockData;
const DELETE_IMPORT_SUCCESS_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Your import was deleted",
    [locales_1.Locales.FR]: "Votre import a été supprimé",
    [locales_1.Locales.ES]: "Su importación se ha eliminado",
    [locales_1.Locales.DE]: "Ihr Import wurde gelöscht",
});
const DELETE_IMPORT_ERROR_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Your import was not deleted",
    [locales_1.Locales.FR]: "Votre import n'a pas été supprimé",
    [locales_1.Locales.ES]: "Su importación no se ha eliminado",
    [locales_1.Locales.DE]: "Ihr Import wurde nicht gelöscht",
});
const buildDeleteImportSuccessMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(DELETE_IMPORT_SUCCESS_SUBJECT, locale), firstName = "John", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
});
exports.buildDeleteImportSuccessMockData = buildDeleteImportSuccessMockData;
const buildDeleteImportErrorMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(DELETE_IMPORT_ERROR_SUBJECT, locale), firstName = "John", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
});
exports.buildDeleteImportErrorMockData = buildDeleteImportErrorMockData;
